// PackagingSlip.js
import React from 'react';
import Barcode from 'react-barcode';
import { base_logo_url } from '../../apis/constants';
import NoLogo from '../../assets/carrier logos/No Logo.png';

const PackagingSlip = ({
  contentRef,
  openPrintPDfDialogData,
  rowData,
  numberOfPrints,
  numberOfPrintsColmnVise,
  isMobile
}) => {
  if (!openPrintPDfDialogData) return null;

  return (
    <div ref={contentRef} id='pdf-content' style={{ padding: 1 }}>
      {[...Array(numberOfPrintsColmnVise)].map((_, oindex) => (
        <div
          key={oindex}
          style={
            isMobile
              ? {
                  minWidth: '3.4in',
                  maxWidth: '3.4in',
                  minHeight: '6in',
                  maxHeight: '6in',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  overflow: 'hidden'
                }
              : {
                  minWidth: '4in',
                  maxWidth: '4in',
                  minHeight: '6in',
                  maxHeight: '6in',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  overflow: 'hidden'
                }
          }
        >
          {[...Array(numberOfPrints)].map((_, index) => (
            <div
              key={index}
              style={{ pageBreakAfter: 'always' }}
              className='p-2 d-flex flex-column w-100'
            >
              {/* From */}
              <div className='border border-dark border-2 p-0 px-1 py-1'>
                <div className='labels-label'>From:</div>
                <div className='labels-value'>
                  {openPrintPDfDialogData.originCompany}
                </div>
                <div className='labels-value'>
                  {openPrintPDfDialogData.originAddress}{' '}
                  {rowData?.originAddress2 && `, ${rowData?.originAddress2}`}
                </div>
                <div className='labels-value'>
                  {`${openPrintPDfDialogData.originCity}, ${openPrintPDfDialogData.originState}, ${openPrintPDfDialogData.originZipCode}`}
                </div>
              </div>

              {/* To */}
              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <div className='labels-label'>To:</div>
                <div className='labels-value'>
                  {openPrintPDfDialogData.destinationCompany}
                </div>
                <div className='labels-value'>
                  {openPrintPDfDialogData.destinationAddress}{' '}
                  {rowData?.destinationAddress2 &&
                    `, ${rowData?.destinationAddress2}`}
                </div>
                <div className='labels-value'>
                  {`${openPrintPDfDialogData.destinationCity}, ${openPrintPDfDialogData.destinationState}, ${openPrintPDfDialogData.destinationZipCode}`}
                </div>
              </div>

              {/* PRO# */}
              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <div
                  className='d-flex align-items-center justify-content-center'
                  style={{ textAlign: 'left' }}
                >
                  <span className='labels-label' style={{ fontSize: 20 }}>
                    PRO#{' '}
                  </span>
                  <span
                    className='labels-value'
                    style={{
                      fontSize: 20,
                      fontWeight: 'bold',
                      color: 'black'
                    }}
                  >
                    {rowData?.proNumber}
                  </span>
                </div>
                {openPrintPDfDialogData.proNumber && (
                  <div className='d-flex justify-content-center w-100'>
                    <Barcode
                      margin={1}
                      displayValue={false}
                      height={40}
                      fontSize={15}
                      width={2}
                      value={openPrintPDfDialogData.proNumber}
                    />
                  </div>
                )}
              </div>

              {/* Other details */}
              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <span className='labels-label mb-1'>BOL#:</span>
                <span className='labels-value'>
                  {openPrintPDfDialogData.bolNumber}
                </span>
              </div>

              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <span className='labels-label mb-1'>Pickup Date:</span>
                <span className='labels-value'>
                  {openPrintPDfDialogData.pickupDate}
                </span>
              </div>

              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <span className='labels-label mb-1'>Handling Units#:</span>
                <span className='labels-value'>
                  {openPrintPDfDialogData?.details?.reduce(
                    (sum, item) => sum + item.units,
                    0
                  )}
                </span>
              </div>

              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <span className='labels-label mb-1'># of Pieces:</span>
                <span className='labels-value'>
                  {openPrintPDfDialogData?.details?.reduce(
                    (sum, item) => sum + item.pieces,
                    0
                  )}
                </span>
              </div>

              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <span className='labels-label mb-1'>Shipment #:</span>
                <span className='labels-value'>
                  {openPrintPDfDialogData.soNumber}
                </span>
              </div>

              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <span className='labels-label mb-1'>PO#:</span>
                <span className='labels-value'>
                  {openPrintPDfDialogData.clientPONumber}
                </span>
              </div>

              {/* Carrier */}
              <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                <div className='labels-label' style={{ fontSize: '18px' }}>
                  Carrier: {openPrintPDfDialogData.carrierName}
                </div>
                <img
                  style={{
                    objectFit: 'contain',
                    width: 'auto',
                    maxWidth: '80%',
                    height: '0.9in'
                  }}
                  alt={openPrintPDfDialogData.carrierName}
                  src={
                    openPrintPDfDialogData.carrierLogo
                      ? base_logo_url + openPrintPDfDialogData.carrierLogo
                      : NoLogo
                  }
                />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PackagingSlip;
